import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { boardItem, BoardService } from '../board.service';

@Component({
  selector: 'app-quick-board',
  templateUrl: './quick-board.component.html',
  styleUrls: ['./quick-board.component.css']
})
export class QuickBoardComponent implements OnInit {

  boards : boardItem[] = []
  constructor(private boardService :BoardService) { }

  ngOnInit(): void {
    this.boardService.List().subscribe((data)=>{
      this.boards = data
    })
  }
  addBoardForm = new FormGroup({
    barcode: new FormControl(''),
    name: new FormControl(''),
  });

  showDiv = {
    previous : false
  }

  addToBoard(){
    const dataForm = this.addBoardForm.value;
    this.boardService.AddItem(dataForm).subscribe();
    this.addBoardForm.reset();
    this.boardService.List().subscribe((data)=>{
      this.boards = data
    })
  }

  deleteItem(id:number){
    this.boardService.Delete(id).subscribe();
    this.boardService.List().subscribe((data)=>{
      this.boards = data
    })
  }
}
